module.exports = __webpack_public_path__ + "img/oType.c0c0457e.png";